import styled from 'styled-components';
import { flexbox, grid, layout, space, typography } from 'styled-system';

export const Box = styled.div`
  ${layout}
  ${space}
  ${flexbox}
  ${typography}
`;

export const Col = styled.div`
  ${space}
  ${flexbox}
  align-items: ${props => props.alignItems || 'flex-start'};
  display: flex;
  flex-direction: column;
  width: ${props => props.span * 8.33}%;
`;

export const Row = styled.div`
  ${space}
  ${flexbox}
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const Spacing = styled.div`
  height: ${props => props.mult * 8}px;
  width: 100%;
`;

export const Grid = styled.div`
  ${grid}
  display: grid;
  grid-column-gap: 32px;
  margin: ${props => (props.gutter ? '0 16px' : 0)};
`;

export const GridRow = styled.div`
  ${space}
  ${grid}
  display: grid;
  grid-column-gap: 16px;
  width: 100%;
`;
